export default {
  title: {
    move: 'Move To Group',
    add: 'Add To Group',
    edit: 'Edit Group',
    remove: 'Remove from the group'
  },
  label: {
    fromGroup: 'From',
    toGroup: 'To',
    comment: 'Comment',
    currentGroup: 'Current Group',
    talentPoolGroup: 'Talent Pool Group',
    groupName: 'Group Name',
    groupCandidateCount: 'Number of Candidates',
    operation: 'Action',
    selectGroup: 'Select Group'
  },
  placeholder: {

  },
  btn: {
    toNewGroup: 'To NEW Group',
    toExistedGroup: 'To EXISTING Group',
    addGroup: 'Add',
    moveGroup: 'Move',
    removeFromGroup: 'Remove',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  message: {
    addGroupTip: 'You can choose to add to the current group or the talent pool group',
    existedGroupName: 'Group name already exists, please enter another name',
    addGroupTalentPage: 'You can add to the selected group, remove from the selected group, or move into another group',
    deleteGroupMessageTip: 'Are you sure to delete the group? This operation is irreversible',
    deleteGroupMessageTitle: 'Tip',
    cancelDeleteGroup: 'Cancel Delete'
  }
}
